export type ReshootSource = {
  jobId: string;
  productNo: number;
};

export function reusableReshootSource(
  source: ReshootSource | null,
  selectedProductNo: number,
) {
  return source?.productNo === selectedProductNo ? source : null;
}
